// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"88943e65","488":"c23487d7","977":"2f18abd6"}[chunkId] + ".chunk.js";
};